/* eslint-disable consistent-return */
/* eslint-disable no-void */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-console */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-useless-return */
/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
import React, { useState } from "react";

import { useParams, useNavigate, useLocation, NavigateFunction } from "react-router-dom";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Drawer from "@mui/material/Drawer";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuItem from "@mui/material/MenuItem";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { useTheme } from "@mui/material/styles";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import DownloadIcon from "@mui/icons-material/Download";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import clipboard from "clipboardy";

import {
    CAREER_STATUS_CERTIFIED,
    CAREER_STATUS_COMPLETED,
    CAREER_STATUS_INVALID,
    CAREER_STATUS_NOT_CERTIFIED,
    CAREER_STATUS_NOT_CERTIFIED_CANCELED,
    CAREER_STATUS_NOT_CERTIFIED_DISABLED,
    CAREER_STATUS_NOT_COMPLETED,
    CAREER_STATUS_NOT_COMPLETED_CANCELED,
    CAREER_STATUS_NOT_COMPLETED_DISABLED,
    CAREER_STATUS_NOT_COMPLETED_SUSPENDED,
    CAREER_STATUS_NOT_EXECUTED,
    CAREER_STATUS_NOT_LEARNED,
    CareerStatuses,
    HEIGHT_MOBILE_FOOTER,
} from "../../../Constants";

import BaseFrame from "../../../component/wrapper/BaseFrame";
import ItemizeGroupTag from "../../../component/tag/ItemizeGroupTag";
import ItemizeCareerTypeTag from "../../../component/tag/ItemizeCareerTypeTag";
import SompoLoading from "../../../component/loading/SompoLoading";
import { HomeLink } from "../../../component/breadcrums/Links";
import { useScreenSize, ZINDEX_FOOTER } from "../../../component/Theme";
import SompoProgressBar from "../../../component/progress/SompoProgressBar";
import SompoCardBadge from "../../../component/card/SompoCardBadge";
import { ApproverSelect, ApproverSelectionContainer, DEFAULT_APPROVER, DUMMY_APPROVERS } from "../../../component/approver/ApproverSelection";

import CareerInfoStudentHistoryService, {
    CareerInfoData,
    ClassInfoItem,
    TaskItem,
    EnqueteItem,
    AppliableItem,
    CategoryItem,
    CareerHistoryItemOnGoing,
    CareerHistoryItemResult,
    AproverOptionItemCancel,
} from "../../../logic/api/CareerInfoStudentHistoryService";
import MaterialFileDownloadService, { MaterialFileDownloadResponse } from "../../../logic/api/MaterialFileDownloadService";
import ComplCertificateDownloadService, { ComplCertificateDownloadResponse } from "../../../logic/api/ComplCertificateDownloadService";
import LmFunctionService from "../../../logic/api/LmFunctionService";
import ApplyService from "../../../logic/api/ApplyService";
import CancelService from "../../../logic/api/ReqCancelService";
import SaveStCancelService from "../../../logic/api/SaveStCancelService";
import PlaceFileDownloadService, { PlaceFileDownloadResponse } from "../../../logic/api/PlaceFileDownloadService";

import WindowOpener from "../../../logic/windowOpener";
import { openConfirmationDialog, showErrorMessage } from "../../../logic/hook/useDialogStateHelper";
import { downloadFile } from "../../../logic/io/FileUtils";
import { currentDate, DateFormats, parseJSDateTime, separateStartAndEndDate } from "../../../logic/datetime";
import { findLatestHistory, isELearning, isGroupTraining } from "../../../logic/utility/TrainingUtil";
import { adjustThumbnail } from "../../../logic/utility/thumbnailUtil";
import SompoContext from "../../../logic/context/SompoContext";

/* =======================================
 * Domestic constants.
 * ======================================= */
const ATTEND_STATUS = {
    APPLIED_FOR: "0", // 受講申請中
    APPLYING_FOR_CANCEL: "1", // 取消申請中
    NON_ATTENDANCE: "2", // 期間前
    UNLEARNED: "3", // 未学習
    LEARNING: "4", // 学習中
    DOING: "5", // 実施中
    APPLYING_RECORD: "6", // 実績申請中
    COMPLETE: "7", // 修了
    NOT_COMPLETED: "8", // 未修了
    INVALID: "9", // 失効
    NOT_COMPLETED_DISABLED: "11", // 未修了(受講不可)
    NOT_COMPLETED_CANCELED: "12", // 未修了(キャンセル)
    NOT_COMPLETED_SUSPENDED: "13", // 未修了(クラス中止)
    NOT_LEARNED: "14", // 未受講
    APPLYING_EXECUTE2: "16", // 実施申請中
    CERTIFIED: "17", // 認定
    NOT_CERTIFIED: "18", // 未認定
    NOT_CERTIFIED_DISABLED: "19", // 未認定(実施不可)
    NOT_CERTIFIED_CANCELED: "20", // 未認定(キャンセル)
    NOT_EXECUTED: "21", // 未実施
    NON_APPLICATION: "22", // 申請前
    OTHERS: "99", // その他
};

const BUTTON_LABEL = {
    [ATTEND_STATUS.NON_APPLICATION]: "申請する", // 申請前
    [ATTEND_STATUS.APPLIED_FOR]: "申請をキャンセルする", // 受講申請中
    [ATTEND_STATUS.NON_ATTENDANCE]: "受講する", // 期間前
    [ATTEND_STATUS.UNLEARNED]: "受講する", // 未学習
    [ATTEND_STATUS.LEARNING]: "受講する", // 学習中
    [ATTEND_STATUS.DOING]: "受講する", // 実施中
    [ATTEND_STATUS.COMPLETE]: "受講する", // 修了
    [ATTEND_STATUS.NOT_COMPLETED]: "受講する", // 未修了
    [ATTEND_STATUS.NOT_COMPLETED_DISABLED]: "受講する", // 未修了(受講不可)
    [ATTEND_STATUS.NOT_COMPLETED_CANCELED]: "受講する", // 未修了(キャンセル)
    [ATTEND_STATUS.NOT_LEARNED]: "申請する", // 未受講
    [ATTEND_STATUS.APPLYING_EXECUTE2]: "申請をキャンセルする", // 実施申請中
    [ATTEND_STATUS.CERTIFIED]: "受講する", // 認定
    [ATTEND_STATUS.NOT_EXECUTED]: "申請する", // 未実施
};

/* =======================================
 * Interfeces / Types.
 * ======================================= */
type History = CareerHistoryItemOnGoing | CareerHistoryItemResult;
interface State {
    queryText: string;
    check: boolean;
    showCertification: boolean;
    classId?: string;
}

// クラスごとのカード情報
interface ClassCardProps {
    careerInfoData: CareerInfoData;
    item: ClassInfoItem;
}

// 講座の詳細情報
interface RowProps {
    name: string;
    content: string | React.JSX.Element | undefined;
}

/* =======================================
 * Logics.
 * ======================================= */
const careerService = new CareerInfoStudentHistoryService();
const applyService = new ApplyService();
const lmFunctionService = new LmFunctionService();
const cancelService = new CancelService();
const saveStCancelService = new SaveStCancelService();
const materialFileDownloadService = new MaterialFileDownloadService();
const certificateDownloadService = new ComplCertificateDownloadService();
const placeFileDownloadService = new PlaceFileDownloadService();

/**
 * 受講申請可否の判定
 * @param appliable クラスごとの申請可否
 * @returns 1クラスでも受講申請可能であれば[受講申請可: true]
 */
const isAppliable = (appliable: AppliableItem[]) => (appliable || []).some((a) => a.appliable);

/**
 * 再受講申請可否の判定
 * @param careerInfo 講座のマスタデータ
 * @param appliable クラスごとの申請可否
 * @param latestHistory 最新の受講履歴
 * @returns 再受講申請可能であれば[再受講申請可: true]
 */
const isReappliable = (appliable: AppliableItem[], latestHistory: History | undefined) => {
    // データのチェック
    if (!latestHistory || !("retakeOkFlg" in latestHistory)) return false;

    // 再受講可
    if (!isAppliable(appliable) || !latestHistory.retakeOkFlg) return false;

    // 終端系ステータスを確認：使用している履歴(実施中/実績)4APIで、共通でステータスIDが取得できないので、やむなくステータスのラベルで判定
    const { status } = latestHistory;
    return status
        ? [
              CareerStatuses[CAREER_STATUS_COMPLETED],
              CareerStatuses[CAREER_STATUS_NOT_COMPLETED],
              CareerStatuses[CAREER_STATUS_INVALID],
              CareerStatuses[CAREER_STATUS_NOT_COMPLETED_DISABLED],
              CareerStatuses[CAREER_STATUS_NOT_COMPLETED_CANCELED],
              CareerStatuses[CAREER_STATUS_NOT_COMPLETED_SUSPENDED],
              CareerStatuses[CAREER_STATUS_NOT_LEARNED],
              CareerStatuses[CAREER_STATUS_CERTIFIED],
              CareerStatuses[CAREER_STATUS_NOT_CERTIFIED],
              CareerStatuses[CAREER_STATUS_NOT_CERTIFIED_DISABLED],
              CareerStatuses[CAREER_STATUS_NOT_CERTIFIED_CANCELED],
              CareerStatuses[CAREER_STATUS_NOT_EXECUTED],
          ].includes(status)
        : false;
};

const getCareerTypeId = (careerInfoData: CareerInfoData | undefined) => {
    const { careerTypeId = "" } = careerInfoData || {};
    return String(careerTypeId);
};

// 期間の判定を行う。
const periodDetermination = (periodStr: string) => {
    let period = false;
    const dateStr = separateStartAndEndDate(periodStr);

    const start = parseJSDateTime(dateStr.startDate, DateFormats.YYYYMMDDHHMM);
    const end = parseJSDateTime(dateStr.endDate, DateFormats.YYYYMMDDHHMM);
    const now = currentDate();

    // 期間内外判定
    // 期間外であればfalse
    if (now >= start! && now <= end!) {
        period = true;
    }
    return period;
};

const findValidTargetClass = (list: ClassInfoItem[]) => {
    let target: ClassInfoItem = {} as ClassInfoItem;
    // クラスIDの指定がない場合は、クラスの一覧から申請可能なクラスを探し、最初にヒットしたクラスをセットする。
    // 申請可能なクラスを検索する。
    for (const item of list) {
        if (item.appliable) {
            target = item;
            break;
        }
    }
    return target;
};

// 履歴から申請種別(aplType)を取得する。
const getAplType = (history: History) => ("aplType" in history ? history.aplType : undefined);

// 受講文字列の1桁目を取得する。
const getJukouButtonDisplay = (history: History) => (history.jukou || "0,").split(",")[0];

// 受講するボタンの表示判定
const needDisplayAttendButton = (careerTypeId: string, history: History): boolean => {
    // eラーニングでない場合はボタン非表示とする
    if (!isELearning(careerTypeId)) return false;

    // 履歴がない場合はボタン非表示とする
    if (!history) return false;

    const jukou = getJukouButtonDisplay(history);
    // 受講文字列の1桁目(受講ボタン表示フラグ)が"1"かチェック
    if (jukou === "1") {
        // 実施期間外フラグが実施期間外 && 課題提出可能数が0 && アンケート回答可能数が0の場合はボタン非表示とする
        const { outOfPeriodFlg, kadaiWithin, enqueteWithin } = history;
        return Boolean(!outOfPeriodFlg || kadaiWithin!=0 || enqueteWithin!=0 );
    }

    // 実施中の履歴で、統合版ステータスが申請中の場合はボタン非表示とする
    const aplType = getAplType(history);
    if (aplType) {
        switch (history.status) {
            case CareerStatuses["0"]: // 受講申請中
            case CareerStatuses["1"]: // 取消申請中
            case CareerStatuses["6"]: // 実績申請中
                return false;
            default:
                break;
        }
    }

    // アンケート解答可能フラグ、または課題提出可能フラグが立っている場合はボタンを表示する
    return history.enqueteDispFlg || history.taskReportOkFlg;
};

const isWithinPeriod = (careerInfoData: CareerInfoData | undefined, classInfoList: ClassInfoItem[], attendCareer: History | undefined) => {
    let periodStr = "";
    let period = false;

    if (attendCareer) {
        periodStr = attendCareer.jissiKikan;
        period = periodDetermination(periodStr);
        //======================================attendCareer.statusは文字列型であり、ATTEND_STATUS.NOT_LEARNEDは数値型であるため、以下の分岐コードはdefault部分のみが実行されます。=======================================================
        // 実施中、実績に存在する講座の場合(再受講の場合を除く)
        // 受講申請中の場合
        // switch (attendCareer.status) {
        //     case ATTEND_STATUS.NOT_LEARNED: // 未受講
        //     case ATTEND_STATUS.NOT_EXECUTED: // 未実施
        //         // クラス申請時、申請できるクラスが1件以上存在するかを確認する。
        //         // クラス選択や申請ボタンの表示切替、フッターの高さの調節に使用する。
        //         classInfoList.forEach((item) => {
        //             if (period) {
        //                 return;
        //             }
        //             // 個別指定クラスであるかを判定
        //             if (item.classId === "CL000000") {
        //                 // 申請対象であるかを判定
        //                 //＃19046対応改修　item.appliable
        //                 if (careerInfoData?.jyukoNoClass === "1" && item.appliable) {
        //                     period = true;
        //                     return;
        //                 }
        //                 return;
        //             }
        //             periodStr = item.application;
        //             // 1クラスでも申請可能であればtrueを設定する。
        //             const showApplicaiton = periodDetermination(periodStr);
        //             //＃19046対応改修　item.appliable
        //             if (showApplicaiton && item.appliable) {
        //                 period = true;
        //             }
        //         });
        //         break;
        //     default:
        //         periodStr = attendCareer.jissiKikan;
        //         period = periodDetermination(periodStr);
        //         break;
        // }
        //=============================================================================================
    } else {
        // 未申請の講座の場合
        // クラス申請時、申請できるクラスが1件以上存在するかを確認する。
        // クラス選択や申請ボタンの表示切替、フッターの高さの調節に使用する。
        classInfoList.forEach((item) => {
            // 1クラスでも申請可能であればtrueを設定する。
            if (item.appliable) {
                period = true;
            }
            return;
        });
    }
    return period;
};

// アンケートまたは課題の表示判定
const needDisplayEnqueteAndTaskReportButton = (
    careerTypeId: string,
    okFlg: boolean | undefined,
    numberFraction: string | undefined,
    aplType: string | undefined
) => {
    // eラーニングの場合はアンケート回答可能フラグ、または課題提出可能フラグに従う
    if (isELearning(careerTypeId)) return okFlg || false;

    // アンケート（回答数/全体数）または課題（提出数/全体数）の全体数が数値でなければボタンを非表示とする
    if (!numberFraction) return false;
    const searchResults = /^\d+\/(\d+)$/.exec(numberFraction || "");
    if (!searchResults || parseInt(searchResults[1], 10) === 0) return false;

    // 申請タイプが受講申請(0)の場合はボタンを非表示とする
    return aplType !== "0";
};

const needDisplayEnquetesAndTasks = (careerInfoData: CareerInfoData, attendCareer: History | undefined, displayType: string) => {
    let displayEnquetes = true;
    let displayTasks = true;
    switch (displayType) {
        case ATTEND_STATUS.UNLEARNED: // 未学習
        case ATTEND_STATUS.LEARNING: // 学習中
        case ATTEND_STATUS.DOING: // 実施中
        case ATTEND_STATUS.COMPLETE: // 修了
        case ATTEND_STATUS.CERTIFIED: // 認定
        case ATTEND_STATUS.NON_ATTENDANCE: // 期間前
        case ATTEND_STATUS.NOT_COMPLETED: // 未修了
        case ATTEND_STATUS.INVALID: // 失効
        case ATTEND_STATUS.NOT_COMPLETED_DISABLED: // 未修了(受講不可)
        case ATTEND_STATUS.NOT_COMPLETED_CANCELED: // 未修了(キャンセル)
        case ATTEND_STATUS.NOT_COMPLETED_SUSPENDED: // 未修了(クラス中止)
        case ATTEND_STATUS.NOT_CERTIFIED: // 未認定
        case ATTEND_STATUS.NOT_CERTIFIED_DISABLED: // 未認定(実施不可)
        case ATTEND_STATUS.NOT_CERTIFIED_CANCELED: // 未認定(キャンセル)
        case ATTEND_STATUS.APPLYING_FOR_CANCEL: // 取消申請中
        case ATTEND_STATUS.APPLYING_RECORD: // 実績申請中
            if (!attendCareer) {
                displayEnquetes = false;
                displayTasks = false;
            } else {
                const aplType = getAplType(attendCareer);
                const careerTypeId = getCareerTypeId(careerInfoData);

                // アンケート回答ボタン：回答可能な場合はボタンを表示する
                displayEnquetes = needDisplayEnqueteAndTaskReportButton(careerTypeId, attendCareer.enqueteDispFlg, attendCareer.enquete, aplType);

                // 課題提出ボタン：提出可能な場合はボタンを表示する
                displayTasks = needDisplayEnqueteAndTaskReportButton(careerTypeId, attendCareer.taskReportOkFlg, attendCareer.kadai, aplType);
            }
            break;
        default:
            displayEnquetes = false;
            displayTasks = false;
            break;
    }
    return { displayEnquetes, displayTasks };
};

// 受講取消の表示可否
const showCancelAttend = (attendCareer: History | undefined) => attendCareer && "lecCancelOkFlg" in attendCareer && attendCareer.lecCancelOkFlg;

// 受講申請の承認者選択の表示可否
const showApproverSelectionApply = (displayType: string, appliable: boolean) => {
    const showApplyButton = displayType
        ? [
              ATTEND_STATUS.NOT_LEARNED, // 未受講
              ATTEND_STATUS.NOT_EXECUTED, // 未実施
              ATTEND_STATUS.NON_APPLICATION, // 申請前
          ].includes(displayType)
        : false;
    return showApplyButton && appliable;
};

// タグに表示するテキストを返却する
const getTagText = (targetCategory: CategoryItem | undefined): string => {
    if (!targetCategory) return "";
    return targetCategory.categoryName;
};

const getStudyTime = (careerInfoData: CareerInfoData | undefined): string => {
    const { studyTime = "" } = careerInfoData || {};
    if (!studyTime) {
        return "";
    }
    return `${studyTime}分`;
};

const checkTaskAndEnquete = (attendCareer: History | undefined): boolean => {
    if (!attendCareer) return false;
    return Boolean(attendCareer.enqueteDispFlg || attendCareer.taskReportOkFlg);
};

const getMessage = (
    careerInfoData: CareerInfoData | undefined,
    classInfoList: ClassInfoItem[],
    attendCareer: History | undefined,
    displayType: string,
    appliable: boolean
): string | undefined => {
    const withinPeriod = isWithinPeriod(careerInfoData, classInfoList, attendCareer);
    const displayEnqueteOrReport = checkTaskAndEnquete(attendCareer);
    let _message;
    switch (displayType) {
        case ATTEND_STATUS.APPLIED_FOR: // 受講申請中
            _message = "※受講申請中です。回答までしばらくお待ちください。";
            break;
        case ATTEND_STATUS.APPLYING_FOR_CANCEL: // 取消申請中
            _message = "※取消申請中です。";
            break;
        case ATTEND_STATUS.NON_ATTENDANCE: // 期間前
            _message = "※受講期間前です。受講期間までお待ちください。";
            break;
        case ATTEND_STATUS.UNLEARNED: // 未学習
        case ATTEND_STATUS.LEARNING: // 学習中
            if (!withinPeriod) {
                _message = "※受講期間外です。";
            }
            break;
        case ATTEND_STATUS.DOING: // 実施中
            if (!withinPeriod && !displayEnqueteOrReport) {
                _message = "※受講期間外です。";
            }
            break;
        case ATTEND_STATUS.APPLYING_RECORD: // 実績申請中
            _message = "※実績申請中です。";
            break;
        case ATTEND_STATUS.COMPLETE: // 修了
            break;
        case ATTEND_STATUS.NOT_COMPLETED: // 未修了
            _message = "※未修了です。";
            break;
        case ATTEND_STATUS.INVALID: // 失効
            _message = "※失効しています。";
            break;
        case ATTEND_STATUS.NOT_COMPLETED_DISABLED: // 未修了(受講不可)
            _message = "※未修了です。(受講不可)";
            break;
        case ATTEND_STATUS.NOT_COMPLETED_CANCELED: // 未修了(キャンセル)
            _message = "※未修了です。(キャンセル)";
            break;
        case ATTEND_STATUS.NOT_COMPLETED_SUSPENDED: // 未修了(クラス中止)
            _message = "※未修了です。(クラス中止)";
            break;
        case ATTEND_STATUS.NOT_LEARNED: // 未受講
        case ATTEND_STATUS.NOT_EXECUTED: // 未実施
        case ATTEND_STATUS.NON_APPLICATION: // 申請前
            if (!appliable) {
                // 受講申請が不可能な場合
                _message = "※本講座は受講申請できません。";
            } else if (!withinPeriod) {
                // 期間外の場合
                _message = "※受講期間外です。";
            } else {
                _message = "※希望する日時を選択して、受講申請してください。";
            }
            break;
        case ATTEND_STATUS.APPLYING_EXECUTE2: // 実施申請中
            if (withinPeriod) {
                _message = "※実施申請中です。回答までしばらくお待ちください。";
            } else {
                _message = "※受講期間外です。";
            }
            break;
        case ATTEND_STATUS.CERTIFIED: // 認定
            _message = "※認定済みです。";
            break;
        case ATTEND_STATUS.NOT_CERTIFIED: // 未認定
            _message = "※未認定です。";
            break;
        case ATTEND_STATUS.NOT_CERTIFIED_DISABLED: // 未認定(実施不可)
            _message = "※未認定です。(実施不可)";
            break;
        case ATTEND_STATUS.NOT_CERTIFIED_CANCELED: // 未認定(キャンセル)
            _message = "※未認定です。(キャンセル)";
            break;
        default:
            _message = "";
            break;
    }
    return _message;
};

const fetchCareer = async (
    careerId: string,
    classId: string | undefined
): Promise<{
    careerInfoData: CareerInfoData;
    category: CategoryItem | undefined;
    classInfoList: ClassInfoItem[];
    attendCareer: History | undefined;
    targetClass: ClassInfoItem | undefined;
    taskList: TaskItem[] | undefined;
    targetTask: TaskItem | undefined;
    questionnaireList: EnqueteItem[] | undefined;
    targetQuestionnaire: EnqueteItem | undefined;
    appliable: boolean;
    reappliable: boolean;
    reapplyClass: ClassInfoItem | undefined;
    approverList1: ApproverSelect;
    approverList2: ApproverSelect;
    displayType: string;
}> => {
    // マスタデータ、受講履歴をfetch
    const { careerInfoData, careerClassInfoList, categories, enquetes, tasks, appliable, approvers, histories } = await careerService.fetch({
        careerId,
    });

	//カンタンクラス申込期間に現在日が含まれるか判定
    appliable.map(item => {
        const matched = careerClassInfoList.find(e => e.classId === item.classId);
        if(matched && item.classId !== "CL000000" && item.appliable){
            item.appliable = periodDetermination(matched.application);
        }
    });

	//appliableフィールドの値と一致させる
    careerClassInfoList.map(item => {
        const matched = appliable.find(e => e.classId === item.classId);
        item.appliable = matched ? matched.appliable : false;
    });

    // 結果データに整形
    // カテゴリ: レスポンスの最上位の最初の分類を表示する
    const mainCategory = (categories || []).find(() => true);

    // 最新の受講履歴
    const { onGoing, result } = histories;
    const latestHistory: History | undefined = findLatestHistory(onGoing, result);

    // 対象のクラス
    let targetClass: ClassInfoItem | undefined;
    if (latestHistory) {
        // 受講履歴がある: 受講履歴のクラス
        targetClass = (careerClassInfoList || []).find((c) => c.classId === latestHistory.classId);
    } else if (classId) {
        // クラスID指定での表示: 指定されたクラス
        targetClass = (careerClassInfoList || []).find((c) => c.classId === classId);
    } else {
        // それ以外: 有効な最初のクラス
        targetClass = findValidTargetClass(careerClassInfoList);
    }

    // 受講申請関連
    const _appliable = isAppliable(appliable);
    const reappliable = isReappliable(appliable, latestHistory);
    const reapplyClass = reappliable ? findValidTargetClass(careerClassInfoList) : undefined;

    // 承認者関連
    const { apply, cancel } = approvers;
    let approvers1: ApproverSelect = DUMMY_APPROVERS;
    let approvers2: ApproverSelect = DUMMY_APPROVERS;
    if (_appliable || reappliable) {
        // 受講申請・再受講申請
        const { approverList1, approverList2 } = apply;
        approvers1 = {
            approver: (approverList1 && approverList1.length > 0) ? approverList1[0] : DEFAULT_APPROVER,
            approverList: approverList1 || [],
        };
        approvers2 = {
            approver: (approverList2 && approverList2.length > 0) ? approverList2[0] : DEFAULT_APPROVER,
            approverList: approverList2 || [],
        };
    } else if (latestHistory && showCancelAttend(latestHistory)) {
        // 受講取消: プロパティ名を揃えるために別オブジェクトに転記
        const { approverList1, approverList2 } = cancel;
        const adjust = (_approvers: AproverOptionItemCancel[]) =>
            (_approvers || []).map((_approver) => ({
                id: _approver.userId,
                name: _approver.approverOptionString,
            }));
        const adjustedApproverList1 = adjust(approverList1);
        const adjustedApproverList2 = adjust(approverList2);
        approvers1 = {
            approver: (adjustedApproverList1 && adjustedApproverList1.length > 0) ? adjustedApproverList1[0] : DEFAULT_APPROVER,
            approverList: adjustedApproverList1,
        };
        approvers2 = {
            approver: (adjustedApproverList2 && adjustedApproverList2.length > 0) ? adjustedApproverList2[0] : DEFAULT_APPROVER,
            approverList: adjustedApproverList2,
        };
    }

    // 課題
    let taskList: TaskItem[] | undefined;
    let targetTask: TaskItem | undefined;
    if (latestHistory) {
        const { taskList: _taskList } = (tasks || []).find((task) => task.classId === latestHistory.classId)!;
        taskList = _taskList;
        targetTask = taskList.find((task) => !task.expired);
    }

    // アンケート
    let enqueteList: EnqueteItem[] | undefined;
    let targetEnquete: EnqueteItem | undefined;
    if (latestHistory) {
        const { enqueteList: _enqueteList } = (enquetes || []).find((enquete) => enquete.classId === latestHistory.classId)!;
        enqueteList = _enqueteList;
        targetEnquete = enqueteList.find((enquete) => !enquete.expired);
    }

    // 表示モード: 受講履歴ベースで決まる
    let displayType = ATTEND_STATUS.OTHERS;
    if (!latestHistory) {
        // 履歴なし: 未申請の状態
        displayType = ATTEND_STATUS.NON_APPLICATION;
    } else {
        // 履歴あり: ステータスで分岐
        const { status } = latestHistory;
        switch (status) {
            case CareerStatuses["0"]: // 受講申請中
                displayType = ATTEND_STATUS.APPLIED_FOR;
                break;
            case CareerStatuses["1"]: // 取消申請中
                displayType = ATTEND_STATUS.APPLYING_FOR_CANCEL;
                break;
            case CareerStatuses["2"]: // 期間前
                displayType = ATTEND_STATUS.NON_ATTENDANCE;
                break;
            case CareerStatuses["3"]: // 未学習
                displayType = ATTEND_STATUS.UNLEARNED;
                break;
            case CareerStatuses["4"]: // 学習中
                displayType = ATTEND_STATUS.LEARNING;
                break;
            case CareerStatuses["5"]: // 実施中
                displayType = ATTEND_STATUS.DOING;
                break;
            case CareerStatuses["6"]: // 実績申請中
                displayType = ATTEND_STATUS.APPLYING_RECORD;
                break;
            case CareerStatuses["7"]: // 修了
                displayType = ATTEND_STATUS.COMPLETE;
                break;
            case CareerStatuses["8"]: // 未修了
                displayType = ATTEND_STATUS.NOT_COMPLETED;
                break;
            case CareerStatuses["9"]: // 失効
                displayType = ATTEND_STATUS.INVALID;
                break;
            case CareerStatuses["11"]: // 未修了(受講不可)
                displayType = ATTEND_STATUS.NOT_COMPLETED_DISABLED;
                break;
            case CareerStatuses["12"]: // 未修了(キャンセル)
                displayType = ATTEND_STATUS.NOT_COMPLETED_CANCELED;
                break;
            case CareerStatuses["13"]: // 未修了(クラス中止)
                displayType = ATTEND_STATUS.NOT_COMPLETED_SUSPENDED;
                break;
            case CareerStatuses["14"]: // 未受講
                displayType = ATTEND_STATUS.NOT_LEARNED;
                break;
            case CareerStatuses["16"]: // 実施申請中
                displayType = ATTEND_STATUS.APPLYING_EXECUTE2;
                break;
            case CareerStatuses["17"]: // 認定
                displayType = ATTEND_STATUS.CERTIFIED;
                break;
            case CareerStatuses["18"]: // 未認定
                displayType = ATTEND_STATUS.NOT_CERTIFIED;
                break;
            case CareerStatuses["19"]: // 未認定(実施不可)
                displayType = ATTEND_STATUS.NOT_CERTIFIED_DISABLED;
                break;
            case CareerStatuses["20"]: // 未認定(キャンセル)
                displayType = ATTEND_STATUS.NOT_CERTIFIED_CANCELED;
                break;
            case CareerStatuses["21"]: // 未実施
                displayType = ATTEND_STATUS.NOT_EXECUTED;
                break;
            default:
                break;
        }
    }

    // 結果データ
    return {
        careerInfoData,
        category: mainCategory,
        classInfoList: careerClassInfoList,
        attendCareer: latestHistory,
        targetClass,
        taskList,
        targetTask,
        questionnaireList: enqueteList,
        targetQuestionnaire: targetEnquete,
        appliable: _appliable,
        reappliable,
        reapplyClass,
        approverList1: approvers1,
        approverList2: approvers2,
        displayType,
    };
};

/** 受講申請の共通処理(初回・再受講) */
const _applyInternal = async (
    careerInfoData: CareerInfoData,
    targetClass: ClassInfoItem,
    approvers1: ApproverSelect,
    approvers2: ApproverSelect,
    navigate: NavigateFunction
): Promise<void> => {
    const { careerId } = careerInfoData;
    const { classId } = targetClass;

    const navigateToApplication = () =>
        navigate(`/application/${careerId}/${classId}`, {
            state: {
                careerInfoData,
                targetClass,
            },
        });

    await applyService.apply(
        {
            careerType: 0,
            applies: [
                {
                    careerId,
                    classId,
                    approverId1: approvers1.approver?.id,
                    approverId2: approvers2.approver?.id,
                },
            ],
        },
        navigateToApplication,
        (error: any) => {
            console.error(error);
            const { message } = error;
            if (ApplyService.isCapacityOverError(message)) {
                showErrorMessage({ message, error });
            } else if((message || "").includes(MESSAGE_CHECK_APPROVER1) && (message || "").includes(MESSAGE_CHECK_APPROVER)) {
                //1段階承認を承認できる方が設定されていないため申請できません。
                showErrorMessage({ message: ERROR_MESSAGE_APPROVER1, error });
            } else if((message || "").includes(MESSAGE_CHECK_APPROVER2) && (message || "").includes(MESSAGE_CHECK_APPROVER)) {
                //2段階承認を承認できる方が設定されていないため申請できません。
                showErrorMessage({ message: ERROR_MESSAGE_APPROVER2, error });
            } else {
                //showErrorMessage({ message:message.replaceAll('null:',''), error });
                showErrorMessage({ message: "受講申請に失敗しました。", error });
            }
        }
    );
};
export const MESSAGE_CHECK_APPROVER = "承認できる方が設定されていないため申請できません。";
export const MESSAGE_CHECK_APPROVER1 = "1段階承認";
export const MESSAGE_CHECK_APPROVER2 = "2段階承認";
export const ERROR_MESSAGE_APPROVER1 = "1段階承認を承認できる方が設定されていないため申請できません。";
export const ERROR_MESSAGE_APPROVER2 = "2段階承認を承認できる方が設定されていないため申請できません。";

/** 樹高申請 */
const apply = (
    careerInfoData: CareerInfoData,
    targetClass: ClassInfoItem,
    approvers1: ApproverSelect,
    approvers2: ApproverSelect,
    navigate: NavigateFunction
) => {
    const fetch = async () => {
        await _applyInternal(careerInfoData, targetClass, approvers1, approvers2, navigate);
    };
    void fetch();
};

/** 再受講申請 */
const reApply = (
    careerInfoData: CareerInfoData,
    targetClass: ClassInfoItem,
    approvers1: ApproverSelect,
    approvers2: ApproverSelect,
    navigate: NavigateFunction
) => {
    const fetch = async () => {
        await _applyInternal(careerInfoData, targetClass, approvers1, approvers2, navigate);
    };
    openConfirmationDialog({
        message: "再受講申請を行いますか？",
        resolve: () => void fetch(),
    });
};

/** 申請取消 */
const cancelApply = (careerInfoData: CareerInfoData, targetClass: ClassInfoItem, navigate: NavigateFunction) => {
    const { careerId } = careerInfoData;
    const { classId } = targetClass;
    const navigateToResult = () => {
        navigate(`/cancel/${careerId}/${classId}`, {
            state: {
                careerInfoData,
                targetClass,
            },
        });
    };
    const fetch = async () => {
        await cancelService.cancelApplication(
            {
                careerId,
                classId,
            },
            navigateToResult,
            (error: any) => {
                console.error(error);
                showErrorMessage({ message: "取消申請に失敗しました。", error });
            }
        );
    };
    void fetch();
};

/** 受講取消 */
const cancelAttend = (
    careerInfoData: CareerInfoData,
    targetClass: ClassInfoItem,
    approvers1: ApproverSelect,
    approvers2: ApproverSelect,
    navigate: NavigateFunction
) => {
    const { careerId } = careerInfoData;
    const { classId } = targetClass;
    // 受講取消申請
    const _fetch = async () => {
        const navigateToCancelAttend = () =>
            navigate(`/cancelAttend/${careerId}/${classId}`, {
                state: {
                    careerInfoData,
                    targetClass,
                },
            });

        await saveStCancelService.cancelAttendCareer(
            {
                careerId,
                classId,
                acceptManagerUserId: approvers1.approver?.id,
                acceptManagerUserId2: approvers2.approver?.id,
            },
            navigateToCancelAttend,
            (error: any) => {
                console.error(error);
                const { message } = error;
                if((message || "").includes(MESSAGE_CHECK_APPROVER1) && (message || "").includes(MESSAGE_CHECK_APPROVER)) {
                    //1段階承認を承認できる方が設定されていないため申請できません。
                    showErrorMessage({ message: ERROR_MESSAGE_APPROVER1, error });
                } else if((message || "").includes(MESSAGE_CHECK_APPROVER2) && (message || "").includes(MESSAGE_CHECK_APPROVER)) {
                    //2段階承認を承認できる方が設定されていないため申請できません。
                    showErrorMessage({ message: ERROR_MESSAGE_APPROVER2, error });
                } else {
                    showErrorMessage({ message: "受講取消申請に失敗しました。", error });
                }
            }
        );
    };
    void _fetch();
};

/** eラーニング受講 */
const attend = (careerInfoData: CareerInfoData, targetClass: ClassInfoItem, mobile: boolean) => {
    const { careerId } = careerInfoData;
    const { classId } = targetClass;
    const fetch = async () => {
        await lmFunctionService.openELearning(
            {
                career_id: careerId,
                class_id: classId,
            },
            (error: any) => {
                console.error(error);
                showErrorMessage({ message: "受講画面の表示に失敗しました。", error });
            },
            mobile
        );
    };
    WindowOpener.openLmWindow(fetch);
};

/** 修了証明書ダウンロード */
const downloadCertificate = (careerId: string) => {
    const fetch = async () => {
        await certificateDownloadService.complCertificateDownload(
            {
                careerId,
            },
            (response: ComplCertificateDownloadResponse) => {
                const { fileData, contentType } = response;
                WindowOpener.openBase64Data(fileData, contentType);
            },
            (error: any) => {
                console.error(error);
                showErrorMessage({ message: "修了証明書のダウンロードに失敗しました。", error });
            }
        );
    };
    void fetch();
};

const downloadMaterialFile = (careerId: string, fileIndex: number, extension: string) => {
    const _fetch = async () => {
        await materialFileDownloadService.materialFileDownload(
            {
                careerId,
                fileIndex: String(fileIndex),
            },
            (response: MaterialFileDownloadResponse) => {
                // 暫定対応：ファイル名の末尾が拡張子と一致しない場合、ファイル名+拡張子をDLファイル名とする
                const { fileData, contentType, fileName } = response;
                const downloadFileName = fileName.endsWith(extension) ? fileName : `${fileName}${extension}`;
                downloadFile(downloadFileName, fileData, contentType);
            },
            (error: unknown) => {
                const message = "研修資料のダウンロードに失敗しました。";
                console.error(message, error);
                showErrorMessage({ message });
            }
        );
    };
    void _fetch();
};

const answerEnquete = (career: CareerInfoData, clazz: ClassInfoItem, enquete: EnqueteItem, mobile: boolean) => {
    const { careerId } = career;
    const { classId } = clazz;
    const { id, enqueteType, iconClass } = enquete;
    const fetch = async () => {
        await lmFunctionService.openAnswerQuestionnaire(
            {
                career_id: careerId,
                class_id: classId,
                questionnaire_id: id,
                type: enqueteType,
                flg: iconClass === "enquete-complete" ? "1" : "0",
            },
            (error: any) => {
                console.error(error);
                showErrorMessage({ message: "アンケート回答画面を表示できませんでした", error });
            },
            mobile
        );
    };
    WindowOpener.openLmWindow(fetch);
};

const submitTask = (career: CareerInfoData, clazz: ClassInfoItem, task: TaskItem, mobile: boolean) => {
    const { careerId } = career;
    const { classId } = clazz;
    const { seq, resultStatus } = task;
    const fetch = async () => {
        await lmFunctionService.openSubmitTask(
            {
                career_id: careerId,
                class_id: classId,
                seq,
                flg: "2",
                subjectStatusflg: resultStatus === "提出済み" ? "1" : "0",
            },
            (error: any) => {
                console.error(error);
                showErrorMessage({ message: "課題提出画面を表示できませんでした", error });
            },
            mobile
        );
    };
    WindowOpener.openLmWindow(fetch);
};

const showClassRoom = (url: string) => {
    // 指定URLを新規タブで開く。
    WindowOpener.open(url);
};
const copyClassRoom = (url: string) => {
    // ※clipboardyライブラリはlocalhost、またはhttps環境でのみ確認可能。
    // ※http環境では確認出来ないことに注意。
    const copy = async () => {
        await clipboard.write(url);
    };
    void copy();
};
const downloadClassRoom = (classInfo: ClassInfoItem, file: string) => {
    const fetch = async () => {
        await placeFileDownloadService.placeFileDownload(
            {
                careerId: classInfo.careerId,
                classId: classInfo.classId,
            },
            (response: PlaceFileDownloadResponse) => {
                const { fileData, contentType } = response;
                downloadFile(file, fileData, contentType);
            },
            (error: unknown) => {
                console.error(error);
                showErrorMessage({ message: "地図ファイルのダウンロードに失敗しました。", error });
            }
        );
    };
    void fetch();
};

/* =======================================
 * Sub Components.
 * ======================================= */
/**
 * 詳細情報の1項目
 * @param props name:項目名、content:表示内容
 * @returns 詳細情報の1項目のReact DOM
 */
const Row = (props: RowProps) => {
    const { desktop, mobile } = useScreenSize();
    return (
        <Grid container direction={desktop ? "row" : "column"} alignItems="flex-start" columns={20} sx={{ mb: 2 }}>
            <Grid item xs={desktop ? 5 : 20} sm={desktop ? 4 : 20} md={desktop ? 3 : 20}>
                <Typography sx={{ fontWeight: "bold" }}>{props.name}</Typography>
            </Grid>
            <Grid item xs={desktop ? 15 : 20} sm={desktop ? 16 : 20} md={desktop ? 17 : 20} sx={{ ...(mobile && { width: "100%" }) }}>
                {(() => {
                    const { content } = props;
                    if (!content || typeof content === "string") {
                        return (content || "").split("\n").map((line) => {
                            if (line) {
                                return (
                                    <Typography variant="h6" sx={{ overflowWrap: "break-word" }}>
                                        {line}
                                    </Typography>
                                );
                            }
                            return (
                                <Typography
                                    variant="h6"
                                    sx={{ overflowWrap: "break-word" }}
                                    dangerouslySetInnerHTML={{
                                        __html: "&nbsp;",
                                    }}
                                />
                            );
                        });
                    }
                    return content;
                })()}
            </Grid>
        </Grid>
    );
};

const ClassCardItemLabel = (props: ClassCardProps) => {
    const { careerInfoData, item } = props;
    const careerTypeId = getCareerTypeId(careerInfoData);
    return (
        <Grid container direction="column">
            {/* クラス名 */}
            <Typography className="ellipses" sx={{ wordBreak: "break-all" }}>
                {item.className}
            </Typography>

            {/* 実施期間 */}
            <Typography>{item.startToEndDate}</Typography>

            {/* 集合研修の場合のみ実施場所 */}
            {isGroupTraining(careerTypeId) && (
                <Typography className="ellipses" sx={{ wordBreak: "break-all", overflowX: "hidden" }}>
                    {item.classRoomNm || item.classroom || ""}
                </Typography>
            )}
        </Grid>
    );
};
const ClassListItemLabel = (props: ClassCardProps) => {
    const { careerInfoData, item } = props;
    const careerTypeId = getCareerTypeId(careerInfoData);
    const classRoomNm = (isGroupTraining(careerTypeId) && (item.classRoomNm || item.classroom)) || "";
    return (
        <Typography
            style={{
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
            }}
        >
            {`${item.className} ${item.startToEndDate} ${classRoomNm}`}
        </Typography>
    );
};
const ClassSelection = (props: {
    show: boolean;
    careerInfoData: CareerInfoData;
    classInfoList: ClassInfoItem[];
    targetClass: ClassInfoItem | undefined;
    setTargetClass: React.Dispatch<React.SetStateAction<ClassInfoItem | undefined>>;
}) => {
    // Props.
    const { show, careerInfoData, classInfoList, targetClass, setTargetClass } = props;

    // Hooks.
    const theme = useTheme();
    const { desktop } = useScreenSize();

    // Event handlers.
    const handleChangeTargetClass = (event: SelectChangeEvent) => {
        // console.log("ClassSelection handleChangeTargetClass", event.target.value);
        const newTargetClass = classInfoList.find((e) => e.classId === event.target.value);
        if (!newTargetClass) return;
        setTargetClass(newTargetClass);
    };

    if (!show) return <></>;

    // console.log("ClassSelection render", targetClass?.classId);
    return desktop ? (
        <>
            <Grid item sx={{ width: "100%" }} container justifyContent="center">
                <RadioGroup
                    aria-label="trainingDateTime"
                    id="trainingDateTime"
                    name="trainingDateTime"
                    sx={{ width: "100%", pl: "10%" }}
                    value={targetClass?.classId}
                    onChange={handleChangeTargetClass}
                >
                    {classInfoList.map((item, index) => {
                        return (
                            //申請不可なら表示しない
                            <>
                                {item.appliable && (
                                    <FormControlLabel
                                    value={item.classId}
                                    control={<Radio color="primary" />}
                                    label={<ClassCardItemLabel careerInfoData={careerInfoData} item={item} />}
                                    key={index}
                                    sx={{
                                        border: `1px solid ${targetClass?.classId === item.classId ? theme.palette.primary.main : "#ddd"}`,
                                        borderRadius: "5px",
                                        mb: 0.5,
                                    }}
                                    />

                                )}
                            </>
                            
                        );
                    })}
                </RadioGroup>
            </Grid>
        </>
    ) : (
        <>
            <Grid item sx={{ width: "100%" }} container justifyContent="center">
                <Select
                    aria-label="trainingDateTime"
                    id="trainingDateTime"
                    name="trainingDateTime"
                    sx={{ width: "100%" }}
                    value={targetClass?.classId}
                    onChange={handleChangeTargetClass}
                    MenuProps={{
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "center",
                        },
                        transformOrigin: {
                            vertical: "bottom",
                            horizontal: "center",
                        },
                        PaperProps: { sx: { maxHeight: "60%" } },
                        sx: { zIndex: ZINDEX_FOOTER + 1 },
                    }}
                >
                    {classInfoList.map((item, index) => {
                        return (
                            //申請不可なら表示しない
                            <>
                                {item.appliable && (
                                    <MenuItem value={item.classId} key={index} >
                                        <ClassListItemLabel careerInfoData={careerInfoData} item={item} />
                                    </MenuItem>

                                )}
                            </>
                            
                        );
                    })}
                </Select>
            </Grid>
        </>
    );
};

// 承認者選択用のイベントハンドラを作成
const createHandleChangeApprover = (approverSelect: ApproverSelect, setApproverSelect: React.Dispatch<React.SetStateAction<ApproverSelect>>) => {
    const handleChangeApprover = (event: SelectChangeEvent) => {
        const newApprover = (approverSelect.approverList || []).find((e) => e.id === event.target.value);
        if (!newApprover) return;
        setApproverSelect({
            ...approverSelect,
            approver: newApprover,
        });
    };
    return handleChangeApprover;
};

// 実施場所のアイコン。
const ClassRoomIcon = (props: { url: string | undefined; file: string | undefined }) => {
    const { desktop } = useScreenSize();
    const { url, file } = props;

    // 空のアイコン：テキストの位置合わせ用。
    const EmptyIcon = () => <OpenInNewIcon sx={{ opacity: 0 }} />;

    // URLもファイルも存在しなければ空のアイコンとする。
    if (!url && !file) return <EmptyIcon />;

    if (url) {
        return desktop ? <OpenInNewIcon /> : <ContentCopyIcon />;
    }
    if (file) {
        return <DownloadIcon />;
    }
};

// 講座概要の実施場所。
const ClassRoom = (props: { classInfo: ClassInfoItem }) => {
    // Hooks.
    const { desktop } = useScreenSize();

    // Props.
    const { classInfo } = props;
    const { className, classRoomNm, classroom, placeUrl: url, placeFileName: file } = classInfo;

    // Event handlers.
    const handleClassRoomClicked = () => {
        if (!url && !file) return;
        if (url) {
            if (desktop) {
                // PC版の場合はURLを新規タブで開く。
                showClassRoom(url);
            } else {
                // モバイル版の場合はURLをクリップボードに保存する。
                copyClassRoom(url);
            }
            return;
        }
        if (file) {
            downloadClassRoom(classInfo, file);
            return;
        }
    };

    // Logics.
    const classRoom = classRoomNm || classroom || "";
    const link = url || file;

    // Render component.
    if (!classRoom) return <></>;
    return (
        <Grid
            container
            direction={"row"}
            flexWrap={"nowrap"}
            alignItems={"center"}
            columnGap={1}
            sx={{
                color: "primary.main",
                transition: "all 0.2s ease-in-out",
                mb: 1,
                ...(link && { "&:hover": { opacity: 0.7, cursor: "pointer" } }),
            }}
            onClick={handleClassRoomClicked}
        >
            <ClassRoomIcon {...{ url, file }} />
            <Typography
                sx={{
                    fontWeight: "bold",
                    ...(link && { textDecoration: "underline" }),
                    whiteSpace: "normal",
                    wordBreak: "break-all",
                }}
            >
                {`${className}(${classRoom})`}
            </Typography>
        </Grid>
    );
};

const ClassRooms = (props: { classInfoList: ClassInfoItem[] }) => {
    const { classInfoList } = props;
    const { mobile } = useScreenSize();
    const show = mobile && classInfoList.some((classInfo) => (classInfo.classRoomNm || classInfo.classroom) && classInfo.placeUrl && classInfo.appliable);

    const Message = () =>
        show && (
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    m: 1,
                }}
            >
                <Typography
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        whiteSpace: "normal",
                        wordBreak: "break-all",
                    }}
                >
                    {"※"}
                    <ContentCopyIcon fontSize="small" />
                    {"をタップでURLがコピーされます。"}
                </Typography>
            </Box>
        );

    const Data = () =>
        (classInfoList || [])
        .filter(classInfo => classInfo.appliable)
        .map((classInfo, index) => (
            <ClassRoom key={`TrainingDetail-classRoom-${classInfo.careerId}-${classInfo.classId}-${index}`} classInfo={classInfo} />
        ));
    return (
        <>
            <Message />
            <Data />
        </>
    );
};

const TrainingDetail = () => {
    // Context.
    const sompoContext = React.useContext(SompoContext);

    // Hooks.
    const { desktop, mobile } = useScreenSize();
    const theme = useTheme();
    const navigate = useNavigate();
    const { careerId } = useParams(); // パスパラメータ
    const location = useLocation();
    const { classId } = (location.state || {}) as State;

    // States.
    // 講座
    const [careerInfoData, setCareerInfoData] = useState<CareerInfoData | undefined>();
    const [targetCategory, setTargetCategory] = useState<CategoryItem | undefined>();
    const [classInfoList, setClassInfoList] = useState<ClassInfoItem[]>([]); // クラス
    const [approvers1, setApprovers1] = useState<ApproverSelect>(DUMMY_APPROVERS); // 1段階承認者
    const [approvers2, setApprovers2] = useState<ApproverSelect>(DUMMY_APPROVERS); // 2段階承認者
    const [taskList, setTaskList] = useState<TaskItem[]>([]); // 課題一覧
    const [questionnaireList, setQuestionnaireList] = useState<EnqueteItem[]>([]); // アンケート一覧

    // 受講履歴
    const [attendCareer, setAttendCareer] = useState<History | undefined>();

    // 画面で使用
    const [displayType, setDisplayType] = useState(ATTEND_STATUS.OTHERS);
    const [targetClass, setTargetClass] = useState<ClassInfoItem>(); // (受講)選択したクラス
    const [targetTask, setTargetTask] = useState<TaskItem>(); // 選択した課題
    const [targetQuestionnaire, setTargetQuestionnaire] = useState<EnqueteItem>(); // 選択したアンケート
    const [appliable, setAppliable] = React.useState(false); // 申請可否：申請が可能な状態でのみtrue
    const [reAppliable, setReAppliable] = React.useState(false); // 再申請可否：再受講が可能な状態でのみtrue
    const [reApplyClass, setReApplyClass] = React.useState<ClassInfoItem>(); // (再受講)選択したクラス

    // モバイル版のフッタ関連
    const [drawerOpen, setDrawerOpen] = React.useState(false);

    // Side effects.
    React.useEffect(() => {
        const fetch = async () => {
            try {
                // 研修IDのチェック
                if (!careerId) {
                    showErrorMessage({ message: "講座IDが指定されていません。" });
                    sompoContext.setLoading(false);
                    return {};
                }

                // ローディング表示開始
                sompoContext.setLoading(true);

                // マスタデータ・履歴を取得
                const {
                    careerInfoData: _careerInfoData,
                    category: _category,
                    classInfoList: _classInfoList,
                    attendCareer: _attendCareer,
                    targetClass: _targetClass,
                    taskList: _taskList,
                    targetTask: _targetTask,
                    questionnaireList: _questionnaireList,
                    targetQuestionnaire: _targetQuestionnaire,
                    appliable: _appliable,
                    reappliable: _reappliable,
                    reapplyClass: _reapplyClass,
                    approverList1: _approverList1,
                    approverList2: _approverList2,
                    displayType: _displayType,
                } = await fetchCareer(careerId, classId);

                // Set states.
                setCareerInfoData(_careerInfoData);
                setTargetCategory(_category);
                setClassInfoList(_classInfoList || []);
                setAttendCareer(_attendCareer);
                setTargetClass(_targetClass);
                setTaskList(_taskList || []);
                setTargetTask(_targetTask);
                setQuestionnaireList(_questionnaireList || []);
                setTargetQuestionnaire(_targetQuestionnaire);
                setAppliable(_appliable);
                setReAppliable(_reappliable);
                setReApplyClass(_reapplyClass);
                setApprovers1(_approverList1);
                setApprovers2(_approverList2);
                setDisplayType(_displayType);

                // ローディング表示終了
                sompoContext.setLoading(false);
            } catch (error: any) {
                console.error(error);
                showErrorMessage({ message: "講座情報の取得に失敗しました。", error });
                setCareerInfoData(undefined);
                setClassInfoList([]);
                setQuestionnaireList([]);
                setTaskList([]);

                // ローディング表示終了
                sompoContext.setLoading(false);
            }
        };
        void fetch();
    }, []);

    // Event handlers.
    /** 提出する課題を選択したときのイベントハンドラ */
    const handleChangeTargetTask = (event: { target: { value: string } }) => {
        const newTargetTask = taskList.find((e) => e.seq === event.target.value);
        if (!newTargetTask) return;
        setTargetTask(newTargetTask);
    };
    // 課題提出: LM標準画面表示
    const handleClickSubmit = () => submitTask(careerInfoData!, targetClass!, targetTask!, mobile);

    /** 回答するアンケートを選択したときのイベント処理 */
    const handleChangeTargetQuestionnaire = (event: { target: { value: string } }) => {
        const newTargetQuestionnaire = questionnaireList.find((e) => e.id === event.target.value);
        if (!newTargetQuestionnaire) return;
        setTargetQuestionnaire(newTargetQuestionnaire);
    };

    // アンケート回答: LM標準画面表示
    const handleClickAnswer = () => answerEnquete(careerInfoData!, targetClass!, targetQuestionnaire!, mobile);

    /** モバイル版のフッタ開閉を行うイベントハンドラ */
    const toggleDrawer = (newOpen: boolean) => () => {
        setDrawerOpen(newOpen);
    };

    /* ##################################################################
     * ### サブコンポーネント
     * ################################################################## */
    /** サムネイル */
    const AttendImage = () => (
        <>
            {sompoContext.loading ? (
                <Box
                    sx={{
                        minHeight: "130px",
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <SompoLoading position="relative" />
                </Box>
            ) : (
                <Grid sx={{ position: "relative" }}>
                    <Box
                        component={"img"}
                        className="box_image"
                        src={adjustThumbnail(careerInfoData?.careerImageUrl)}
                        sx={{
                            display: "flex",
                            width: "100%",
                            alignItems: "flex-end",
                            borderRadius: "5px",
                            objectFit: "cover",
                            aspectRatio: "16/9",
                        }}
                    />
                    <Grid sx={{ position: "absolute", bottom: "0", right: "0" }}>
                        {careerInfoData && <SompoCardBadge division={careerInfoData.compulsoryId} width="118px" height="98px" variant="h6" />}
                    </Grid>
                </Grid>
            )}
        </>
    );

    /** クラス情報 */
    const AttendClassInfo = () => {
        /** 集合研修の実施場所 */
        const ClassroomTitle = () => {
            if (!attendCareer || isELearning(getCareerTypeId(careerInfoData))) return <></>;
            if (!attendCareer.classroom) return <></>;
            return desktop ? (
                <Typography className="ellipses" sx={{ color: "#000", wordBreak: "break-all", overflowX: "hidden" }}>
                    {attendCareer.classroom}
                </Typography>
            ) : (
                <Typography className="ellipses" sx={{ color: "#000", wordBreak: "break-all", overflowX: "hidden" }}>
                    {attendCareer.classroom}
                </Typography>
            );
        };

        const ClassData = () => (
            <>
                {attendCareer && (
                    <>
                        <Typography className="ellipses" sx={{ color: "#000", wordBreak: "break-all" }}>
                            {attendCareer.classTitle}
                        </Typography>
                        <Typography sx={{ color: "#000" }}>{attendCareer.jissiKikan}</Typography>
                        <ClassroomTitle />
                    </>
                )}
            </>
        );
        const Finished = () => (
            <>
                <Grid container direction="row" alignItems="center">
                    <CheckCircleIcon sx={{ color: "#27AB0C" }} />
                    <Typography sx={{ color: "#000" }}>{"修了しています。"}</Typography>
                </Grid>
            </>
        );

        // eslint-disable-next-line default-case
        switch (displayType) {
            case ATTEND_STATUS.APPLIED_FOR: // 受講申請中
            case ATTEND_STATUS.APPLYING_FOR_CANCEL: // 取消申請中
            case ATTEND_STATUS.NON_ATTENDANCE: // 期間前
            case ATTEND_STATUS.APPLYING_RECORD: // 実績申請中
            case ATTEND_STATUS.NOT_COMPLETED: // 未修了
            case ATTEND_STATUS.INVALID: // 失効
            case ATTEND_STATUS.NOT_COMPLETED_DISABLED: // 未修了(受講不可)
            case ATTEND_STATUS.NOT_COMPLETED_CANCELED: // 未修了(キャンセル)
            case ATTEND_STATUS.NOT_COMPLETED_SUSPENDED: // 未修了(クラス中止)
            case ATTEND_STATUS.APPLYING_EXECUTE2: // 実施申請中
            case ATTEND_STATUS.CERTIFIED: // 認定
            case ATTEND_STATUS.NOT_CERTIFIED: // 未認定
            case ATTEND_STATUS.NOT_CERTIFIED_DISABLED: // 未認定(実施不可)
            case ATTEND_STATUS.NOT_CERTIFIED_CANCELED: // 未認定(キャンセル)
                return <ClassData />;
            case ATTEND_STATUS.COMPLETE: // 修了
                return (
                    <>
                        <Finished />
                        &nbsp;
                        <ClassData />
                    </>
                );
            case ATTEND_STATUS.UNLEARNED: // 未学習
            case ATTEND_STATUS.LEARNING: // 学習中
            case ATTEND_STATUS.DOING: // 実施中
                if (isELearning(getCareerTypeId(careerInfoData))) {
                    return (
                        <>
                            <ClassData />
                            {attendCareer && "progress" in attendCareer && (
                                <Grid sx={{ mt: 1 }}>
                                    <SompoProgressBar progress={String(attendCareer.progress)} />
                                </Grid>
                            )}
                        </>
                    );
                }
                return <ClassData />;
            case ATTEND_STATUS.NOT_LEARNED: // 未受講
            case ATTEND_STATUS.NOT_EXECUTED: // 未実施
            case ATTEND_STATUS.NON_APPLICATION: // 申請前
                return (
                    <ClassSelection
                        show={appliable}
                        careerInfoData={careerInfoData!}
                        classInfoList={classInfoList}
                        targetClass={targetClass}
                        setTargetClass={setTargetClass}
                    />
                );

            case ATTEND_STATUS.OTHERS: // その他（期間外等）
                return <></>;
        }
    };

    /** 表示ボタン */
    const AttendButton = () => {
        const _apply = () => apply(careerInfoData!, targetClass!, approvers1, approvers2, navigate);
        const _cancelApply = () => cancelApply(careerInfoData!, targetClass!, navigate);
        const _attend = () => attend(careerInfoData!, targetClass!, mobile);
        const buttonAction = {
            [ATTEND_STATUS.NON_APPLICATION]: _apply, // 申請前
            [ATTEND_STATUS.APPLIED_FOR]: _cancelApply, // 受講申請中
            [ATTEND_STATUS.NON_ATTENDANCE]: _attend, // 期間前
            [ATTEND_STATUS.UNLEARNED]: _attend, // 未学習
            [ATTEND_STATUS.LEARNING]: _attend, // 学習中
            [ATTEND_STATUS.DOING]: _attend, // 実施中
            [ATTEND_STATUS.COMPLETE]: _attend, // 修了
            [ATTEND_STATUS.NOT_COMPLETED]: _attend, // 未修了
            [ATTEND_STATUS.NOT_COMPLETED_DISABLED]: _attend, // 未修了(受講不可)
            [ATTEND_STATUS.NOT_COMPLETED_CANCELED]: _attend, // 未修了(キャンセル)
            [ATTEND_STATUS.NOT_LEARNED]: _apply, // 未実施
            [ATTEND_STATUS.APPLYING_EXECUTE2]: _cancelApply, // 実施申請中
            [ATTEND_STATUS.CERTIFIED]: _attend, // 認定
            [ATTEND_STATUS.NOT_EXECUTED]: _apply, // 未実施
        };

        const needButtonDisplay = () => {
            let _display = true;
            switch (displayType) {
                // 申請キャンセルボタン：申請取消可能フラグが申請取消可能、最新履歴の統合版ステータスが"受講申請中"の場合はボタンを表示する
                case ATTEND_STATUS.APPLIED_FOR: // 受講申請中
                case ATTEND_STATUS.APPLYING_EXECUTE2: // 実施申請中
                    if (!attendCareer || !("appCancelOkFlg" in attendCareer) || !attendCareer.appCancelOkFlg) _display = false;
                    break;
                // 受講ボタン：受講が可能な場合はボタンの表示判定を行う
                case ATTEND_STATUS.NON_ATTENDANCE: // 期間前
                case ATTEND_STATUS.NOT_COMPLETED: // 未修了
                case ATTEND_STATUS.INVALID: // 失効
                case ATTEND_STATUS.NOT_COMPLETED_DISABLED: // 未修了(受講不可)
                case ATTEND_STATUS.NOT_COMPLETED_CANCELED: // 未修了(キャンセル)
                case ATTEND_STATUS.NOT_COMPLETED_SUSPENDED: // 未修了(クラス中止)
                case ATTEND_STATUS.NOT_CERTIFIED: // 未認定
                case ATTEND_STATUS.NOT_CERTIFIED_DISABLED: // 未認定(実施不可)
                case ATTEND_STATUS.NOT_CERTIFIED_CANCELED: // 未認定(キャンセル)
                case ATTEND_STATUS.UNLEARNED: // 未学習
                case ATTEND_STATUS.LEARNING: // 学習中
                case ATTEND_STATUS.DOING: // 実施中
                case ATTEND_STATUS.COMPLETE: // 修了
                case ATTEND_STATUS.CERTIFIED: // 認定
                    _display = needDisplayAttendButton(getCareerTypeId(careerInfoData), attendCareer!);
                    break;
                // 受講申請ボタン：受講申請が可能な場合はボタンを表示する
                case ATTEND_STATUS.NOT_LEARNED: // 未受講
                case ATTEND_STATUS.NOT_EXECUTED: // 未実施
                case ATTEND_STATUS.NON_APPLICATION: // 申請前
                    _display = appliable;
                    break;
                case ATTEND_STATUS.APPLYING_FOR_CANCEL: // 取消申請中
                case ATTEND_STATUS.APPLYING_RECORD: // 実績申請中
                case ATTEND_STATUS.OTHERS: // その他
                default:
                    _display = false;
                    break;
            }
            return _display;
        };
        return (
            <>
                {needButtonDisplay() && (
                    <Grid item sx={{ width: "100%" }}>
                        <Button
                            fullWidth
                            sx={{
                                color: "white",
                                bgcolor: theme.palette.primary.main,
                                "&:hover": {
                                    bgcolor: theme.palette.primary.main,
                                    opacity: "0.7",
                                    cursor: "pointer",
                                },
                            }}
                            onClick={buttonAction[displayType]}
                        >
                            <Typography>{BUTTON_LABEL[displayType]}</Typography>
                        </Button>
                    </Grid>
                )}
            </>
        );
    };

    /** アンケート */
    const Enquetes = () => {
        // Logics.
        // ステータスの表示値取得
        const getStatusLabel = (status: string) => {
            switch (status) {
                case "enquete-complete":
                    return "回答済み";
                case "enquete":
                    return "未回答";
                default:
                    return "";
            }
        };

        // 暫定対応：APIがアンケート回答期間の空白を文字参照(&#x20;)で返してくるので半角スペースで置換
        const adjustAnswerPeriod = (answerPeriod: string) => (answerPeriod ? answerPeriod.replace(/&#x20;/g, " ") : "");

        // Logics.
        const { displayEnquetes } = needDisplayEnquetesAndTasks(careerInfoData!, attendCareer, displayType);
        const enquetesEmpty = (questionnaireList || []).length === 0;

        // Render component.
        if (!displayEnquetes || enquetesEmpty) return <></>;
        return (
            <Grid container direction="column" justifyContent="space-between" alignItems="center" rowSpacing={2} sx={{ width: "100%", mt: 3 }}>
                <Grid item alignSelf="flex-start" sx={{ color: theme.palette.primary.contrastText }}>
                    <Typography>回答するアンケートを選択してください。</Typography>
                </Grid>

                {/* アンケート一覧 */}
                <Grid item sx={{ width: "100%" }}>
                    {desktop ? (
                        <RadioGroup
                            aria-label="questionnaireList"
                            id="questionnaireList"
                            name="questionnaireList"
                            sx={{ width: "100%" }}
                            value={targetQuestionnaire?.id}
                            onChange={handleChangeTargetQuestionnaire}
                        >
                            {questionnaireList.map((item, index) => (
                                <Box
                                    sx={{
                                        width: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        columnGap: 1,
                                        border: `1px solid ${targetQuestionnaire?.id === item.id ? theme.palette.primary.main : "#ddd"}`,
                                        borderRadius: "5px",
                                        p: 1,
                                        mb: 0.5,
                                        ml: 0,
                                        mr: 0,
                                    }}
                                    key={index}
                                >
                                    <Typography sx={{ whiteSpace: "nowrap", color: item.expired ? "#B7B8B7" : "" }}>
                                        {item.expired ? "期間外" : getStatusLabel(item.iconClass)}
                                    </Typography>
                                    <FormControlLabel
                                        value={item.id}
                                        disabled={item.expired}
                                        control={<Radio color="primary" />}
                                        label={
                                            <Box sx={{ display: "flex", flexFlow: "column", rowGap: 1 }}>
                                                <Box>{item.text}</Box>
                                                <Box>{adjustAnswerPeriod(item.answerPeriod)}</Box>
                                            </Box>
                                        }
                                        sx={{
                                            whiteSpace: "normal",
                                            wordBreak: "break-all",
                                            width: "100%",
                                        }}
                                    />
                                </Box>
                            ))}
                        </RadioGroup>
                    ) : (
                        <Select
                            aria-label="questionnaireList"
                            id="questionnaireList"
                            name="questionnaireList"
                            sx={{ width: "100%" }}
                            value={targetQuestionnaire?.id}
                            onChange={handleChangeTargetQuestionnaire}
                            MenuProps={{
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "center",
                                },
                                transformOrigin: {
                                    vertical: "bottom",
                                    horizontal: "center",
                                },
                                PaperProps: { sx: { maxHeight: "60%" } },
                                sx: { zIndex: ZINDEX_FOOTER + 1 },
                            }}
                        >
                            {questionnaireList.map((item, index) => (
                                <MenuItem value={item.id} key={index} disabled={item.expired} sx={{ whiteSpace: "normal", wordBreak: "break-all" }}>
                                    {item.expired ? "期間外" : getStatusLabel(item.iconClass)} {item.text} {adjustAnswerPeriod(item.answerPeriod)}
                                </MenuItem>
                            ))}
                        </Select>
                    )}
                </Grid>

                {/* 回答ボタン */}
                <Grid item sx={{ width: "100%" }}>
                    <Button
                        fullWidth
                        sx={{
                            color: "white",
                            bgcolor: targetQuestionnaire ? theme.palette.primary.main : "#ddd",
                            "&:hover": {
                                bgcolor: theme.palette.primary.main,
                                opacity: "0.7",
                                cursor: "pointer",
                            },
                        }}
                        onClick={handleClickAnswer}
                        disabled={Boolean(!targetQuestionnaire)}
                    >
                        <Typography>アンケート回答</Typography>
                    </Button>
                </Grid>
            </Grid>
        );
    };

    /** 課題 */
    const Tasks = () => {
        // Logics.
        const { displayTasks } = needDisplayEnquetesAndTasks(careerInfoData!, attendCareer, displayType);
        const tasksEmpty = (taskList || []).length === 0;

        // Render component.
        if (!displayTasks || tasksEmpty) return <></>;
        return (
            <Grid container direction="column" justifyContent="space-between" alignItems="center" rowSpacing={2} sx={{ width: "100%", mt: 3 }}>
                <Grid item alignSelf="flex-start" sx={{ color: theme.palette.primary.contrastText }}>
                    <Typography>提出する課題を選択してください。</Typography>
                </Grid>
                {/* 課題一覧 */}
                <Grid item sx={{ width: "100%" }}>
                    {desktop ? (
                        <RadioGroup
                            aria-label="taskList"
                            id="taskList"
                            name="taskList"
                            sx={{ width: "100%" }}
                            value={targetTask?.seq}
                            onChange={handleChangeTargetTask}
                        >
                            {taskList.map((item, index) => (
                                <Box
                                    sx={{
                                        width: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        columnGap: 1,
                                        border: `1px solid ${targetTask?.seq === item.seq ? theme.palette.primary.main : "#ddd"}`,
                                        borderRadius: "5px",
                                        p: 1,
                                        mb: 0.5,
                                        ml: 0,
                                        mr: 0,
                                    }}
                                    key={index}
                                >
                                    <Typography sx={{ whiteSpace: "nowrap", color: item.expired ? "#B7B8B7" : "" }}>{item.resultStatus}</Typography>
                                    <FormControlLabel
                                        value={item.seq}
                                        disabled={item.expired}
                                        control={<Radio color="primary" />}
                                        label={
                                            <Box sx={{ display: "flex", flexFlow: "column", rowGap: 1 }}>
                                                <Box>{item.reportFileName}</Box>
                                                <Box>{item.kikan}</Box>
                                            </Box>
                                        }
                                        sx={{
                                            whiteSpace: "normal",
                                            wordBreak: "break-all",
                                            width: "100%",
                                        }}
                                    />
                                </Box>
                            ))}
                        </RadioGroup>
                    ) : (
                        <Select
                            aria-label="taskList"
                            id="taskList"
                            name="taskList"
                            sx={{ width: "100%" }}
                            value={targetTask?.seq}
                            onChange={handleChangeTargetTask}
                            MenuProps={{
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "center",
                                },
                                transformOrigin: {
                                    vertical: "bottom",
                                    horizontal: "center",
                                },
                                PaperProps: { sx: { maxHeight: "60%" } },
                                sx: { zIndex: ZINDEX_FOOTER + 1 },
                            }}
                        >
                            {taskList.map((item, index) => (
                                <MenuItem value={item.seq} key={index} disabled={item.expired} sx={{ whiteSpace: "normal", wordBreak: "break-all" }}>
                                    {item.resultStatus} {item.reportFileName} {item.kikan}
                                </MenuItem>
                            ))}
                        </Select>
                    )}
                </Grid>
                {/* 提出ボタン */}
                <Grid item sx={{ width: "100%" }}>
                    <Button
                        fullWidth
                        sx={{
                            color: "white",
                            bgcolor: targetTask ? theme.palette.primary.main : "#ddd",
                            "&:hover": {
                                bgcolor: theme.palette.primary.main,
                                opacity: "0.7",
                                cursor: "pointer",
                            },
                        }}
                        onClick={handleClickSubmit}
                        disabled={Boolean(!targetTask)}
                    >
                        <Typography>課題提出</Typography>
                    </Button>
                </Grid>
            </Grid>
        );
    };

    /** 受講取消ボタン */
    const CancelAttendButton = () => {
        // 承認者選択用のイベントハンドラを取得
        const handleChangeApprover1 = createHandleChangeApprover(approvers1, setApprovers1);
        const handleChangeApprover2 = createHandleChangeApprover(approvers2, setApprovers2);

        // 受講取消ボタンのイベントハンドラ
        const handleCancelAttend = () => {
            openConfirmationDialog({
                message: "受講を取り消しますか？",
                resolve: () => cancelAttend(careerInfoData!, targetClass!, approvers1, approvers2, navigate),
            });
        };

        return (
            <>
                {showCancelAttend(attendCareer) && (
                    <Grid item container sx={{ width: "100%", mt: 3 }} rowSpacing={1}>
                        <Grid item alignSelf="flex-start" sx={{ color: theme.palette.primary.contrastText }}>
                            <Typography sx={{ textAlign: "center" }}>※受講取消が可能です。</Typography>
                        </Grid>
                        <Grid item sx={{ width: "100%" }}>
                            <ApproverSelectionContainer
                                show={true}
                                approverList1={approvers1.approverList}
                                approver1={approvers1.approver}
                                handleChangeApprover1={handleChangeApprover1}
                                approverList2={approvers2.approverList}
                                approver2={approvers2.approver}
                                handleChangeApprover2={handleChangeApprover2}
                            />
                        </Grid>
                        <Grid item sx={{ width: "100%" }}>
                            <Button
                                fullWidth
                                sx={{
                                    border: "1px solid",
                                    borderColor: theme.palette.primary.contrastText,
                                    bgcolor: "#FFF",
                                    color: theme.palette.primary.contrastText,
                                    "&:hover": {
                                        bgcolor: "#FFF",
                                        opacity: "0.7",
                                        cursor: "pointer",
                                    },
                                }}
                                onClick={handleCancelAttend}
                            >
                                <Typography>受講取消</Typography>
                            </Button>
                        </Grid>
                    </Grid>
                )}
            </>
        );
    };

    /** モバイル版のフッタ */
    const MobileFooter = (props: { drawerOpen: boolean }) => {
        const _message = getMessage(careerInfoData, classInfoList, attendCareer, displayType, appliable);

        // 承認者選択用のイベントハンドラを取得
        const handleChangeApprover1 = createHandleChangeApprover(approvers1, setApprovers1);
        const handleChangeApprover2 = createHandleChangeApprover(approvers2, setApprovers2);

        return (
            <>
                {/* フッタ本体 */}
                <Box sx={{ bgcolor: "white", height: "100%", width: "100%" }}>
                    <Button
                        fullWidth
                        sx={{
                            color: theme.palette.primary.contrastText,
                            bgcolor: "white",
                            py: 0,
                            "&:hover": {
                                bgcolor: "white",
                                opacity: "0.7",
                                cursor: "pointer",
                            },
                            height: "100%",
                        }}
                        onClick={toggleDrawer(true)}
                    >
                        <Grid container sx={{ justifyContent: "center", alignItems: "flex-start", height: "100%" }}>
                            <Grid item sx={{ display: "flex", alignItems: "center", height: "70%" }}>
                                <Typography>操作メニュー</Typography>
                                <ExpandLessIcon />
                            </Grid>
                        </Grid>
                    </Button>
                </Box>

                {/* ドロワ：初期は非表示 */}
                <Drawer
                    anchor="bottom"
                    open={props.drawerOpen}
                    onClose={toggleDrawer(false)}
                    ModalProps={{
                        keepMounted: true,
                    }}
                    sx={{
                        zIndex: ZINDEX_FOOTER,
                        flexDirection: "column",
                        flexWrap: "nowrap",
                        "& .MuiDrawer-root": {
                            height: "100%",
                        },
                        "& .MuiDrawer-paper": {
                            height: "100%",
                        },
                    }}
                >
                    <Grid item flexShrink={1} sx={{ height: HEIGHT_MOBILE_FOOTER, minHeight: HEIGHT_MOBILE_FOOTER, maxHeight: HEIGHT_MOBILE_FOOTER }}>
                        <Button
                            fullWidth
                            sx={{
                                color: theme.palette.primary.contrastText,
                                bgcolor: "white",
                                py: 0,
                                "&:hover": {
                                    bgcolor: "white",
                                    opacity: "0.7",
                                    cursor: "pointer",
                                },
                                height: "100%",
                            }}
                            onClick={toggleDrawer(false)}
                        >
                            <Grid container sx={{ justifyContent: "center", alignItems: "center", height: "100%" }}>
                                <Grid item sx={{ display: "flex", alignItems: "center", height: "70%" }}>
                                    <Typography>操作メニュー</Typography>
                                    <ExpandMoreIcon />
                                </Grid>
                            </Grid>
                        </Button>
                    </Grid>
                    <Grid
                        item
                        container
                        flexGrow={1}
                        flexDirection={"column"}
                        flexWrap={"nowrap"}
                        sx={{
                            minHeight: `calc(100% - ${HEIGHT_MOBILE_FOOTER})`,
                            maxHeight: `calc(100% - ${HEIGHT_MOBILE_FOOTER})`,
                            overflowX: "hidden",
                            overflowY: "auto",
                        }}
                    >
                        <Grid
                            item
                            container
                            direction="column"
                            justifyContent="flex-start"
                            alignItems="center"
                            rowSpacing={1}
                            flexWrap={"nowrap"}
                            sx={{
                                padding: 2,
                                bgcolor: "white",
                            }}
                        >
                            {/* メッセージ */}
                            {_message && (
                                <Grid item sx={{ color: theme.palette.primary.contrastText, width: "100%" }}>
                                    <Typography>{_message}</Typography>
                                </Grid>
                            )}

                            {/* クラス情報 */}
                            <Grid item sx={{ width: "100%" }}>
                                <Grid item sx={{ width: "100%" }}>
                                    <AttendClassInfo />
                                </Grid>
                            </Grid>

                            {/* 承認者選択 */}
                            <Grid item sx={{ width: "100%" }}>
                                <ApproverSelectionContainer
                                    show={showApproverSelectionApply(displayType, appliable)}
                                    approverList1={approvers1.approverList}
                                    approver1={approvers1.approver}
                                    handleChangeApprover1={handleChangeApprover1}
                                    approverList2={approvers2.approverList}
                                    approver2={approvers2.approver}
                                    handleChangeApprover2={handleChangeApprover2}
                                />
                            </Grid>

                            {/* ボタン */}
                            <Grid item sx={{ width: "100%" }}>
                                <AttendButton />
                            </Grid>

                            {/* アンケート */}
                            <Enquetes />

                            {/* 課題提出 */}
                            <Tasks />

                            {/* 受講取消 */}
                            <CancelAttendButton />

                            {/* 再受講可能な場合のみ表示 */}
                            {reAppliable && (
                                <>
                                    {/* メッセージ */}
                                    <Grid item sx={{ color: theme.palette.primary.contrastText, width: "100%", mt: 3 }}>
                                        <Typography>{"※再受講申請が可能な講座です。"}</Typography>
                                        <Typography>
                                            {"下の「申請する」ボタンを押すと、これまでの受講履歴がクリアされ、新たな受講が開始されます。"}
                                        </Typography>
                                    </Grid>

                                    {/* クラス情報 */}
                                    <Grid item sx={{ width: "100%" }}>
                                        <Grid item sx={{ width: "100%" }}>
                                            <ClassSelection
                                                show={true}
                                                careerInfoData={careerInfoData!}
                                                classInfoList={classInfoList}
                                                targetClass={reApplyClass}
                                                setTargetClass={setReApplyClass}
                                            />
                                        </Grid>
                                    </Grid>

                                    {/* 承認者選択 */}
                                    <Grid item sx={{ width: "100%" }}>
                                        <ApproverSelectionContainer
                                            show={true}
                                            approverList1={approvers1.approverList}
                                            approver1={approvers1.approver}
                                            handleChangeApprover1={handleChangeApprover1}
                                            approverList2={approvers2.approverList}
                                            approver2={approvers2.approver}
                                            handleChangeApprover2={handleChangeApprover2}
                                        />
                                    </Grid>

                                    {/* ボタン */}
                                    <Grid item sx={{ width: "100%" }}>
                                        <Grid item sx={{ width: "100%" }}>
                                            <Button
                                                fullWidth
                                                sx={{
                                                    border: "1px solid",
                                                    borderColor: theme.palette.primary.contrastText,
                                                    bgcolor: "#FFF",
                                                    color: theme.palette.primary.contrastText,
                                                    "&:hover": {
                                                        bgcolor: "#FFF",
                                                        opacity: "0.7",
                                                        cursor: "pointer",
                                                    },
                                                }}
                                                onClick={() => {
                                                    reApply(careerInfoData!, reApplyClass!, approvers1, approvers2, navigate);
                                                }}
                                            >
                                                <Typography>{BUTTON_LABEL[ATTEND_STATUS.NON_APPLICATION]}</Typography>
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </>
                            )}
                        </Grid>
                    </Grid>
                </Drawer>
            </>
        );
    };

    /** 講座情報 */
    const TraininngInfo = (props: { drawerOpen?: boolean }) => {
        const _message = getMessage(careerInfoData, classInfoList, attendCareer, displayType, appliable);

        // 承認者選択用のイベントハンドラを取得
        const handleChangeApprover1 = createHandleChangeApprover(approvers1, setApprovers1);
        const handleChangeApprover2 = createHandleChangeApprover(approvers2, setApprovers2);

        return desktop ? (
            <Grid
                item
                container
                direction="column"
                flexWrap={"nowrap"}
                justifyContent="space-between"
                alignItems="center"
                rowSpacing={desktop ? 3 : 0}
                sx={{ padding: 2, bgcolor: "white", height: "100%" }}
            >
                {/* メッセージ */}
                {_message && (
                    <Grid item sx={{ color: theme.palette.primary.contrastText, width: "100%" }}>
                        <Typography>{_message}</Typography>
                    </Grid>
                )}

                {/* クラス情報 */}
                <Grid item sx={{ width: "100%" }}>
                    <Grid item sx={{ width: "100%" }}>
                        <AttendClassInfo />
                    </Grid>
                </Grid>

                {/* 承認者選択 */}
                <Grid item sx={{ width: "100%" }}>
                    <ApproverSelectionContainer
                        show={showApproverSelectionApply(displayType, appliable)}
                        approverList1={approvers1.approverList}
                        approver1={approvers1.approver}
                        handleChangeApprover1={handleChangeApprover1}
                        approverList2={approvers2.approverList}
                        approver2={approvers2.approver}
                        handleChangeApprover2={handleChangeApprover2}
                    />
                </Grid>

                {/* ボタン */}
                <Grid item sx={{ width: "100%" }}>
                    <AttendButton />
                </Grid>

                {/* アンケート */}
                <Enquetes />

                {/* 課題提出 */}
                <Tasks />

                {/* 受講取消 */}
                <CancelAttendButton />

                {/* 再受講可能な場合のみ表示 */}
                {reAppliable && (
                    <>
                        {/* メッセージ */}
                        <Grid item sx={{ color: theme.palette.primary.contrastText, width: "100%", mt: 3 }}>
                            <Typography>{"※再受講申請が可能な講座です。"}</Typography>
                            <Typography>{"下の「申請する」ボタンを押すと、これまでの受講履歴がクリアされ、新たな受講が開始されます。"}</Typography>
                        </Grid>

                        {/* クラス情報 */}
                        <Grid item sx={{ width: "100%" }}>
                            <Grid item sx={{ width: "100%" }}>
                                <ClassSelection
                                    show={true}
                                    careerInfoData={careerInfoData!}
                                    classInfoList={classInfoList}
                                    targetClass={reApplyClass}
                                    setTargetClass={setReApplyClass}
                                />
                            </Grid>
                        </Grid>

                        {/* 承認者選択 */}
                        <Grid item sx={{ width: "100%" }}>
                            <ApproverSelectionContainer
                                show={true}
                                approverList1={approvers1.approverList}
                                approver1={approvers1.approver}
                                handleChangeApprover1={handleChangeApprover1}
                                approverList2={approvers2.approverList}
                                approver2={approvers2.approver}
                                handleChangeApprover2={handleChangeApprover2}
                            />
                        </Grid>

                        {/* ボタン */}
                        <Grid item sx={{ width: "100%" }}>
                            <Grid item sx={{ width: "100%" }}>
                                <Button
                                    fullWidth
                                    sx={{
                                        border: "1px solid",
                                        borderColor: theme.palette.primary.contrastText,
                                        bgcolor: "#FFF",
                                        color: theme.palette.primary.contrastText,
                                        "&:hover": {
                                            bgcolor: "#FFF",
                                            opacity: "0.7",
                                            cursor: "pointer",
                                        },
                                    }}
                                    onClick={() => {
                                        reApply(careerInfoData!, reApplyClass!, approvers1, approvers2, navigate);
                                    }}
                                >
                                    <Typography>{BUTTON_LABEL[ATTEND_STATUS.NON_APPLICATION]}</Typography>
                                </Button>
                            </Grid>
                        </Grid>
                    </>
                )}
            </Grid>
        ) : (
            // 以下フッターのドロワー
            <MobileFooter drawerOpen={props.drawerOpen!} />
        );
    };

    /** カード部（PC: 左半分, mobile: トップ画像） */
    const TrainingCard = () => (
        <Grid container alignItems="center" justifyContent="center">
            <Box
                sx={{
                    width: "100%",
                    bgcolor: "white",
                    borderRadius: "5px",
                    pt: 0,
                }}
            >
                {/* サムネイル */}
                <AttendImage />

                {/* PC版のみ クラス情報 */}
                {desktop && (
                    <Grid container direction="column" sx={{ pt: 0 }}>
                        <TraininngInfo />
                    </Grid>
                )}
            </Box>
        </Grid>
    );

    /** 詳細情報：目的・概要・対象者・備考・研修資料・実施場所・修了証明書・テスト履歴 */
    const Detail = () => {
        const careerTypeId = getCareerTypeId(careerInfoData);
        return (
            <>
                <Row name="目的" content={careerInfoData?.purpose} />
                <Row name="概要" content={careerInfoData?.outline} />
                <Row name="対象者" content={careerInfoData?.target} />
                <Row name="備考" content={careerInfoData?.comment} />
                {/* 集合研修の場合のみ表示 */}
                {isGroupTraining(careerTypeId) && (
                    <>
                        <Row
                            name="研修資料"
                            content={
                                <>
                                    {(careerInfoData?.materialFiles || []).map((file) => (
                                        <Box
                                            key={`materialFile-${file.fileIndex}`}
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                color: "primary.main",
                                                transition: "all 0.2s ease-in-out",
                                                columnGap: 1,
                                                "&:hover": {
                                                    opacity: 0.7,
                                                    cursor: "pointer",
                                                },
                                            }}
                                            onClick={() => downloadMaterialFile(careerId!, file.fileIndex, file.fileType)}
                                        >
                                            <DownloadIcon />
                                            <Typography
                                                sx={{
                                                    fontWeight: "bold",
                                                    textDecoration: "underline",
                                                    whiteSpace: "normal",
                                                    wordBreak: "break-all",
                                                }}
                                            >
                                                {file.fileName}
                                            </Typography>
                                        </Box>
                                    ))}
                                </>
                            }
                        />
                        <Row name="実施場所" content={<ClassRooms classInfoList={classInfoList} />} />
                    </>
                )}
                {/* ステータスが修了の場合のみ表示 */}
                {displayType === ATTEND_STATUS.COMPLETE && (
                    <Row
                        name="修了証明書"
                        content={
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    color: "primary.main",
                                    transition: "all 0.2s ease-in-out",
                                    columnGap: 1,
                                    "&:hover": {
                                        opacity: 0.7,
                                        cursor: "pointer",
                                    },
                                }}
                                onClick={() => downloadCertificate(careerId!)}
                            >
                                <ArrowCircleRightIcon />
                                <Typography
                                    sx={{
                                        fontWeight: "bold",
                                        textDecoration: "underline",
                                        whiteSpace: "normal",
                                        wordBreak: "break-all",
                                    }}
                                >
                                    修了証明書を表示(PCのみ)
                                </Typography>
                            </Box>
                        }
                    />
                )}

                {/* eラーニングかつ、testFlgがtrueの場合のみ表示 */}
                {attendCareer && isELearning(careerTypeId) && "testFlg" in attendCareer && attendCareer.testFlg && (
                    <Row
                        name="テスト履歴"
                        content={
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    color: "primary.main",
                                    transition: "all 0.2s ease-in-out",
                                    columnGap: 1,
                                    "&:hover": {
                                        opacity: 0.7,
                                        cursor: "pointer",
                                    },
                                }}
                                onClick={() => {
                                    navigate(`/training/detail/testHistory/${careerId}/${attendCareer.classId}`);
                                }}
                            >
                                <ArrowCircleRightIcon />
                                <Typography
                                    sx={{
                                        fontWeight: "bold",
                                        textDecoration: "underline",
                                        whiteSpace: "normal",
                                        wordBreak: "break-all",
                                    }}
                                >
                                    テスト履歴を確認
                                </Typography>
                            </Box>
                        }
                    />
                )}
            </>
        );
    };

    /*
     * ##################################################################
     * ### メインとなるReact DOM返却部分
     * ##################################################################
     */
    return (
        <BaseFrame
            width="80%"
            title={careerInfoData?.careerTitle}
            breadcrumbs={[<HomeLink />]}
            content={
                <>
                    {/* fetchが終わるまでローディングアイコンを表示 */}
                    {sompoContext.loading ? (
                        <SompoLoading />
                    ) : (
                        <>
                            {careerInfoData !== null && (
                                <>
                                    <Grid container direction="column" justifyContent="center" alignItems="center">
                                        {/* タグ・学習時間 */}
                                        <Grid item container direction="column" alignItems="flex-start" sx={{ mb: 1 }}>
                                            <Grid item container direction="row" sx={{ gap: 1, mb: 1 }}>
                                                <ItemizeGroupTag>{getTagText(targetCategory)}</ItemizeGroupTag>
                                                <ItemizeCareerTypeTag careerTypeId={getCareerTypeId(careerInfoData)} />
                                            </Grid>
                                            {isELearning(getCareerTypeId(careerInfoData)) && (
                                                <Grid item container direction="row" alignItems="center">
                                                    <AccessTimeIcon sx={{ fontSize: "1.2rem" }} />
                                                    <Typography sx={{ ml: 1 }}>{`標準学習時間： ${getStudyTime(careerInfoData)}`}</Typography>
                                                </Grid>
                                            )}
                                        </Grid>
                                        <Grid item container direction="row" columns={20}>
                                            {/* カード */}
                                            <Grid item xs={20} sm={20} md={5}>
                                                <TrainingCard />
                                            </Grid>
                                            {/* 詳細情報 */}
                                            <Grid item xs={20} sm={20} md={15} sx={{ pl: { xs: 0, sm: 0, md: 8 } }}>
                                                <Detail />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </>
                            )}
                        </>
                    )}
                </>
            }
            footer={!desktop && <TraininngInfo drawerOpen={drawerOpen} />}
            // フッター内要素はモバイル用ドロワー展開のボタンのみのためこの高さで固定
            footerHeight={HEIGHT_MOBILE_FOOTER}
        />
    );
};
export default TrainingDetail;
